import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../components/SectionFormContainer'
import DaycareWizardContext from './DaycareWizardContext'
import useDaycareVisit from '../../../hooks/useDaycareVisit'
import useSelectedHousehold from '../../../hooks/useSelectedHousehold'
import { formatNumsToDollars } from '../../../utils'
import moment from 'moment'

/**
 * Formats the facility's HH:mm drop-off start for display, e.g. '07:00' → '7am'.
 * @param {string} [dropoffBegins] - HH:mm start time; defaults to 07:00
 * @returns {string}
 */
const formatDropoffBegins = (dropoffBegins) => {
	const time = moment(dropoffBegins || '07:00', 'HH:mm')
	return time.format(time.minutes() ? 'h:mma' : 'ha')
}

const Dropoff = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(DaycareWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading, daycare } = useDaycareVisit()
	const { isVip, isPetCare } = useSelectedHousehold()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...wizard_state }
			newValues[attr] = type
			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		if (!daycare) {
			return []
		}

		const earlyPrice = isVip || isPetCare ? 0 : daycare.early_dropoff_fee

		const o = [
			{
				title: 'Standard - Free',
				description: `Drop off begins at ${formatDropoffBegins(daycare.dropoff_begins)}`,
				disabled: loading || wizard_state[attr] === false,
				selected: wizard_state[attr] === false,
				onSelected: () => handleSelection(false)
			},
			{
				title: `Early Drop-off - ${formatNumsToDollars(earlyPrice)}`,
				description: (
					<div>
						<div>Drop-off between {daycare.early_dropoff_hours}</div>
						{isVip || isPetCare ? <div>Free with Membership</div> : null}
					</div>
				),
				disabled: loading || wizard_state[attr] === true,
				selected: wizard_state[attr] === true,
				onSelected: () => handleSelection(true)
			}
		]

		return o
	}, [handleSelection, loading, wizard_state, attr, daycare, isVip])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default Dropoff
